module.exports = __webpack_public_path__ + "images/hello-4cb09ef1a90a8702a43b5549c5298b7d.svg";